import {RootState} from "../../../../../app/store";
import {
    LocationFormSelectionProvider,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../createAndUpdate/LocationForm";
import {ConfigurationRegion, EnquiryProvider, VehicleDataProvider} from "../../../../../api/generated";
import {VehicleTypesByManufacturer} from "../../manufacturerVehicleTypesSlice";

export const createLocationRequestPropertySelector = (rootSelector: (state: RootState) => LocationRequestPartial): LocationFormSelectionProvider<any> => ({
    publicId(state: RootState): string | undefined {
        return rootSelector(state).publicId;
    },
    name(state: RootState): string | undefined {
        return rootSelector(state).name;
    },
    city(state: RootState): string | undefined {
        return rootSelector(state).city;
    },
    postcode(state: RootState): string | undefined {
        return rootSelector(state).postcode;
    },
    phoneNumber(state: RootState): string | undefined {
        return rootSelector(state).phoneNumber;
    },
    mondayWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).workSchedule!.monday;
    },
    tuesdayWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).workSchedule!.tuesday;
    },
    wednesdayWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).workSchedule!.wednesday;
    },
    thursdayWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).workSchedule!.thursday;
    },
    fridayWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).workSchedule!.friday;
    },
    saturdayWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).workSchedule!.saturday;
    },
    sundayWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).workSchedule!.sunday;
    },
    vehicleDataProvider(state: RootState): VehicleDataProvider | undefined {
        return rootSelector(state).vehicleDataProvider;
    },
    advertiserId(state: RootState): string | undefined {
        return rootSelector(state).advertiserId;
    },
    filePath(state: RootState): string | undefined {
        return rootSelector(state).filePath;
    },
    feedId(state: RootState): string | undefined {
        return rootSelector(state).feedId;
    },
    locationHash(state: RootState): string | undefined {
        return rootSelector(state).locationHash;
    },
    locationEmailTranscriptRecipients(state: RootState): string | undefined {
        return rootSelector(state).locationEmailTranscriptRecipients;
    },
    locationEmailFiltrationEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).locationEmailFiltrationEnabled;
    },
    locationEmailTranscriptSummaryEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).locationEmailTranscriptSummaryEnabled;
    },
    enquiryProvider(state: RootState): EnquiryProvider | undefined {
        return rootSelector(state).enquiryProvider;
    },
    dragon2000DealerId(state: RootState): string | undefined {
        return rootSelector(state).dragon2000DealerId;
    },
    em2Region(state: RootState): ConfigurationRegion | undefined {
        return rootSelector(state).em2Region;
    },
    aftersalesEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).aftersalesEnabled;
    },
    serviceBookingUrl(state: RootState): string | undefined {
        return rootSelector(state).serviceBookingUrl;
    },
    recallUrl(state: RootState): string | undefined {
        return rootSelector(state).recallUrl;
    },
    aftersalesEmailTranscriptRecipients(state: RootState): string | undefined {
        return rootSelector(state).aftersalesEmailTranscriptRecipients;
    },
    aftersalesEmailFiltrationEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).aftersalesEmailFiltrationEnabled;
    },
    aftersalesEmailTranscriptSummaryEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).aftersalesEmailTranscriptSummaryEnabled;
    },
    supportedVehicleManufacturers(state: RootState): VehicleTypesByManufacturer | undefined {
        // The generated client types the inline vehicle type enum as plain strings.
        return rootSelector(state).supportedVehicleManufacturers as VehicleTypesByManufacturer | undefined;
    },
    mondayServiceWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).aftersalesWorkSchedule!.monday;
    },
    tuesdayServiceWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).aftersalesWorkSchedule!.tuesday;
    },
    wednesdayServiceWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).aftersalesWorkSchedule!.wednesday;
    },
    thursdayServiceWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).aftersalesWorkSchedule!.thursday;
    },
    fridayServiceWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).aftersalesWorkSchedule!.friday;
    },
    saturdayServiceWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).aftersalesWorkSchedule!.saturday;
    },
    sundayServiceWorkingHoursRequest(state: RootState): WorkingHoursRequest | undefined {
        return rootSelector(state).aftersalesWorkSchedule!.sunday;
    },
});
